import { HttpClient } from "@angular/common/http";
import { EventEmitter, Injectable } from "@angular/core";
import { ApiPaginationResponseDataNonNullable } from "app/shared/models/api-response.model";
import { Observable } from "rxjs";
import { AuthService } from "../../base-module/base-service/auth.service";
import { UtilitesService } from "../../base-module/base-service/utilites.service";
import { ParceiroCreditoModel } from "../model/parceiro-credito.model";

@Injectable()
export class ParceiroCreditoService {
    public empresaPadrao = new EventEmitter<any>();

    constructor(private authService: AuthService, private _http: HttpClient, public utilitesService: UtilitesService) {}

    /**
     * Parceiro Crédito por id
     * @param id ID da Parceiro Crédito
     */
    getById(id: number): Observable<any> {
        return this._http.get(this.utilitesService.urlPrefix + "credito/parceiros/" + id, {
            headers: this.authService.getAuthHeaders(),
        });
    }

    /**
     * Lista de Parceiro Crédito
     * @param id ID da Parceiro Crédito
     */
    getAll(params: Record<string, unknown>): Observable<ApiPaginationResponseDataNonNullable<ParceiroCreditoModel>> {
        const paramHttp = this.utilitesService.formurlencoded(params);
        let env = "";
        if (paramHttp !== null && paramHttp !== "") {
            env = "?" + paramHttp;
        }

        return this._http.get<ApiPaginationResponseDataNonNullable<ParceiroCreditoModel>>(
            this.utilitesService.urlPrefix + "credito/parceiros" + env,
            {
                headers: this.authService.getAuthHeaders(),
            }
        );
    }

    /**
     * Lista de Parceiro Crédito
     * @param id ID da Parceiro Crédito
     */
    search(params: any): Observable<any> {
        const paramHttp = this.utilitesService.formurlencoded(params);
        let env = "";
        if (paramHttp != null && paramHttp != "") {
            env = "?" + paramHttp;
        }

        return this._http.get(this.utilitesService.urlPrefix + "credito/parceiros/search" + env, {
            headers: this.authService.getAuthHeaders(),
        });
    }

    /**
     * Delete de Parceiro Crédito
     * @param id ID da Parceiro Crédito
     */
    delete(id: number): Observable<any> {
        return this._http.delete(this.utilitesService.urlPrefix + "credito/parceiros/" + id, {
            headers: this.authService.getAuthHeaders(),
        });
    }

    /**
     * Cadastra Parceiro Crédito
     * @param params Json Parceiro Crédito
     */
    create(params: any): Observable<any> {
        return this._http.post(this.utilitesService.urlPrefix + "credito/parceiros", JSON.stringify(params), {
            headers: this.authService.getAuthHeaders(),
        });
    }

    /**
     * Atualiza Parceiro Crédito
     * @param params Json Parceiro Crédito
     */
    update(id: number, params: any): Observable<any> {
        return this._http.put(this.utilitesService.urlPrefix + "credito/parceiros/" + id, JSON.stringify(params), {
            headers: this.authService.getAuthHeaders(),
        });
    }
}
